import { createContext } from 'react';
import type { CodeMaster } from '@/types/code-master';

export const CodeMasterContext = createContext<CodeMaster[]>([]);
